import a from "mitt";
import { track as r } from "@ds/tracking/tracking";
const t = a();
let e = "", d = null;
const n = (o) => {
  r({
    action: "modal",
    context: { name: e, status: o }
  });
}, c = () => e !== "", M = (o) => o === e, u = (o = "", l = { cause: "custom" }) => {
  if (e !== "") {
    if (l.cause === "backdropClick" && l.disabled)
      return;
    n("closed"), (o !== "" && o === e || o === "") && (t.emit("close", { name: e, closingEvent: l }), e = "");
  }
}, m = (o, l) => {
  o !== e && c() && u(), e = o, d = l?.target, n("opened"), t.emit("open", e);
}, C = (o, l) => (t.on("open", () => {
  e === o && l({ opened: !0 });
}), t.on("close", ({ closingEvent: s }) => {
  e === o && l({ opened: !1, closingEvent: s }), d?.focus(), d = null;
}), () => {
  t.off("close"), t.off("open");
});
export {
  u as closeModal,
  c as hasModalInPage,
  M as isModalOpened,
  C as onModalUpdate,
  m as openModal
};
